module.exports = __webpack_public_path__ + "img/hays-suchail.222b4b65.jpg";